export const CertificateCodes = {
    AMA_PRA_CREDIT_CERT :"AMA PRA Certificate of Credit (CME) US"
  } as const;
  
  // eslint-disable-next-line @typescript-eslint/no-redeclare
  export type CertificateCodes =
    typeof CertificateCodes[keyof typeof CertificateCodes];
  